// Copyright (c) 2020 Deere & Company

import PartsCoverageSearch from '@deere/cps-it.warranty-model-factory/lib/parts-coverage-search';
import t from 'tcomb';

const Report = t.list(PartsCoverageSearch, 'Report');

export const getDefaultState = () => new Report([]);

export default Report;



// WEBPACK FOOTER //
// ./src/reports/parts-coverage-search/state/report.js